import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PortableText, type PortableTextReactComponents } from "next-sanity";
import { asPortableText, hardBreakHandler, linkMarkHandler, onMissingPortableTextComponent } from "@/components/common/rich-text/shared";

/**
 * Inline portable-text renderer for a form field's rich-text description —
 * e.g. a Selection Card's acceptance copy, a checkbox's helper text (the
 * "unsubscribe any time... Privacy Policy" line under Newsletter Consent /
 * POPI Consent), or the helper/description copy under any other field type
 * (text, file upload, date, select, etc).
 *
 * These descriptions always live inside phrasing content — a `<label>`'s
 * innermost `<span>`, or the `<p>` each field component renders its helper
 * text into — so this renderer emits phrasing content only: `normal` blocks
 * render as `display:block` spans rather than `<p>`, keeping the markup valid
 * while preserving paragraph separation. Links use the shared
 * `linkMarkHandler` (internal page ref → resolved URL, external → href with
 * new tab when set); since an `<a>` is interactive content, clicking it
 * follows the link and does not toggle the card/checkbox per the HTML
 * label-activation rules.
 */
const components: Partial<PortableTextReactComponents> = {
  block: {
    normal: ({
      children
    }) => <span className="block">{children}</span>
  },
  marks: {
    link: linkMarkHandler
  },
  hardBreak: hardBreakHandler
};
export function SelectionCardDescription(t0) {
  const $ = _c(4);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = asPortableText(value);
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="[&_a]:text-text-link [&_a]:underline [&_a:hover]:no-underline"><PortableText value={t1} components={components} onMissingComponent={onMissingPortableTextComponent} /></span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}